
import React, { createContext, useContext, useState, ReactNode } from 'react';
import { LanguageCode } from '../../types';

interface Dictionary {
  [key: string]: string;
}

const DICTIONARIES: Record<LanguageCode, Dictionary> = {
  en: {
    dashboard: 'Dashboard',
    customers: 'Customers',
    subscriptions: 'Subscriptions',
    revenue: 'Revenue',
    save: 'Save Changes',
    back: 'Back',
  },
  es: {
    dashboard: 'Tablero',
    customers: 'Clientes',
    subscriptions: 'Suscripciones',
    revenue: 'Ingresos',
    save: 'Guardar Cambios',
    back: 'Volver',
  },
  de: {
    dashboard: 'Übersicht',
    customers: 'Kunden',
    subscriptions: 'Abonnements',
    revenue: 'Umsatz',
    save: 'Speichern',
    back: 'Zurück',
  },
  fr: {
    dashboard: 'Tableau de bord',
    customers: 'Clients',
    subscriptions: 'Abonnements',
    revenue: 'Revenus',
    save: 'Sauvegarder',
    back: 'Retour',
  },
  hi: {
    dashboard: 'डैशबोर्ड',
    customers: 'ग्राहक',
    subscriptions: 'सदस्यता',
    revenue: 'राजस्व',
    save: 'सहेजें',
    back: 'पीछे',
  }
};

interface LanguageContextType {
  language: LanguageCode;
  setLanguage: (lang: LanguageCode) => void;
  t: (key: string) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<LanguageCode>('en');

  const t = (key: string) => {
    return DICTIONARIES[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useTranslation must be used within a LanguageProvider');
  return context;
};
